import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="footer">
      <ul className="footer-links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/karyon">Karyon</Link></li>
        <li><a href="https://github.com/karyontech">Source Code</a></li>
      </ul>
      <p>&copy; KaryonTech. All code is open source.</p>
    </footer>
  )
}
